(function(){
    'use strict';

    angular
    .module('appback')
    .controller('AppmovController', AppmovController)
 
    AppmovController.$inject = ["AppmovService","$http","$timeout","$uibModal", "$log", "$document","$sce"];
              
    function AppmovController(AppmovService,$http,$timeout,$uibModal, $log, $document,$sce)
    {                         
        var vm = this; 
        vm.crm_id = "";
        vm.puntos = false;
        vm.loading = true;
        vm.pedidoPromo = [];

        vm.getInfoCuenta = function(){
        	AppmovService.getCuentaInfo(vm.crm_id,function(data){
                vm.puntos = data.puntos;
                vm.pedidoPromo = data.pedidos;
                $timeout(function(){
                    vm.loading = false;
                },100)
            });
        }
    }
  
})();